// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M5.283.028a.833.833 0 0 0-.463.404.79.79 0 0 0-.02.588c.052.14.183.274 5.468 5.562L15.684 12l-5.416 5.418c-5.285 5.288-5.416 5.421-5.467 5.562a.747.747 0 0 0 .657 1.014c.135.009.2 0 .314-.042.14-.052.281-.19 5.6-5.505 4.089-4.086 5.484-5.494 5.57-5.623.185-.273.23-.436.23-.824 0-.388-.045-.551-.23-.824-.086-.129-1.481-1.537-5.57-5.623C6.111.298 5.91.1 5.776.05a.883.883 0 0 0-.494-.023"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const ChevronRightIcon = Icon;
export default ChevronRightIcon;
